<template>
  <div id="player_id" style="width: 100%; height: 100%"></div>
</template>

<script>
import { amplitude } from "../plugins/amplitude";

/* global OvenPlayer */
export default {
  name: "OvenPlayerComponent",
  props: {
    webrtcUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isReloading: false,
      isStreaming: false,
      player: null,
    };
  },
  watch: {
    webrtcUrl(newUrl) {
      if (newUrl && this.player) {
        // Reinitialize player with new URL
        this.setupPlayer();
      }
    },
  },
  mounted() {
    this.loadOvenPlayerScript().then(() => {
      this.setupPlayer();
    });
  },
  methods: {
    loadOvenPlayerScript() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src =
          "https://cdn.jsdelivr.net/npm/ovenplayer/dist/ovenplayer.js";
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    toggleStreaming() {
      this.isStreaming = !this.isStreaming;
      this.$emit("streaming-updated", this.isStreaming);
    },
    setupPlayer() {
      // Use provided WebRTC URL or fallback to default
      const webrtcUrl =
        this.webrtcUrl || "wss://indiastream.skyhost.ai:8443/app/stream1";

      // Destroy existing player if it exists
      if (this.player) {
        try {
          this.player.remove();
        } catch (e) {
          console.warn("Error removing existing player:", e);
        }
      }

      this.player = OvenPlayer.create("player_id", {
        autoStart: true,
        controls: false,
        autoFallback: true,
        mute: true,
        sources: [
          {
            label: "webrtc",
            type: "webrtc",
            file: webrtcUrl,
          },
        ],
      });

      this.player.on("player_state", () => {
        this.player.play();
      });

      this.player.on("play", () => {
        this.isStreaming = true;
        amplitude.track("Streaming Started", {});
        this.$emit("streaming-updated", this.isStreaming);
      });

      this.player.on("error", () => {
        this.isStreaming = false;
        this.$emit("streaming-updated", this.isStreaming);
        if (!this.isReloading) {
          this.isReloading = true;
          setTimeout(() => {
            if (
              window.location.hostname === "localhost" ||
              window.location.hostname === "127.0.0.1"
            ) {
              this.loadOvenPlayerScript().then(() => {
                this.setupPlayer();
                this.isReloading = false;
              });
            } else {
              this.setupPlayer();
              this.isReloading = false;
            }
          }, 1000);
        }
      });
    },
  },
  beforeUnmount() {
    if (this.player) {
      try {
        this.player.remove();
      } catch (e) {
        console.warn("Error removing player on unmount:", e);
      }
    }
  },
};
</script>
